<template>
    <div class="card">
        <slot></slot>
    </div>  
</template>
